import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AboutUsImage } from "../../assets";
import ReviewsSlider from "../../components/AboutUs/ReviewSlider/ReviewsSlider";

/**
 * The entry point of the about us page
 *
 * @returns {JSX.Element}
 */

export default function AboutUs() {
  const [t] = useTranslation("global");
  const language = localStorage.getItem("language");
  const [reviewsList, setReviewList] = useState(null);

  useEffect(() => {
    const reviewsList = [
      {
        id: 1,
        customer_comment: t("about_us.customer_comment1"),
        customer_name: t("about_us.customer_name1"),
        customer_designation: "Position, Company name",
      },
      {
        id: 2,
        customer_comment: t("about_us.customer_comment2"),
        customer_name: t("about_us.customer_name2"),
        customer_designation: "Position, Company name",
      },
      {
        id: 3,
        customer_comment: t("about_us.customer_comment3"),
        customer_name: t("about_us.customer_name3"),
        customer_designation: "Position, Company name",
      },
    ];

    if (language !== "ar") {
      reviewsList.push(
        {
          id: 4,
          customer_comment: t("about_us.customer_comment4"),
          customer_name: t("about_us.customer_name4"),
          customer_designation: "Position, Company name",
        },
        {
          id: 5,
          customer_comment: t("about_us.customer_comment5"),
          customer_name: t("about_us.customer_name5"),
          customer_designation: "Position, Company name",
        }
      );
    }
    setReviewList(reviewsList);
  }, [language]);

  return (
    <div>
      {/* first hero section */}
      <div className="text-center text-text_white bg-blend-normal bg-center bg-no-repeat bg-cover bg-airport_ride_bg shadow-[inset_0px_0px_0px_10000px_#e9b838c6] bg-fixed lg:px-64 md:px-32 px-10 lg:py-40 py-10">
        <p className="font-bold text-3xl md:text-5xl mb-6">
          {t("about_us.hero_heading")}
        </p>
        <p className="font-normal text-base md:text-xl md:px-4">
          {t("about_us.hero_paragraph")}
        </p>
      </div>
      {/* first hero section */}

      {/* content section */}
      <div className="mx-6 md:mx-10 lg:mx-16 xl:mx-20 my-6 lg:my-16 xl:my-28 flex flex-col-reverse md:flex-col lg:flex-row justify-between">
        <div className="w-full lg:w-3/5 xl:w-3/5 mx-1 lg:pt-28 lg:pr-16">
          <div className="mb-4 md:mb-5 lg:mb-6 xl:mb-8">
            <p className="font-bold text-2xl md:text-5xl text-text_black">
              {t("about_us.section_heading")}
            </p>
          </div>
          <p className="my-2 md:my-3 lg:my-4 xl:my-5 text-sm lg:text-base">
            <b>{t("about_us.section_first_heading")}</b>
            {t("about_us.section_first_paragraph")}
          </p>
          <p className="my-2 md:my-3 lg:my-4 xl:my-5 text-sm md:text-sm lg:text-base xl:text-base">
            <b>{t("about_us.section_second_heading")}</b>
            {t("about_us.section_second_paragraph")}
          </p>
          <p className="my-2 md:my-3 lg:my-4 xl:my-5 text-sm md:text-sm lg:text-base xl:text-base">
            <b>{t("about_us.section_third_heading")}</b>
            {t("about_us.section_third_paragraph")}
          </p>
        </div>
        <div className="w-full lg:w-2/5 xl:w-2/5 mx-1">
          <img
            src={AboutUsImage}
            alt="Our Services"
            className="w-full h-full"
          />
        </div>
      </div>
      {/* content section */}
      {/* review section */}
      <ReviewsSlider reviewsList={reviewsList} />
      {/* review section */}
    </div>
  );
}
